export const mapMeasurementTypeToFuelType = (measurementType: string | null | undefined): string | undefined => {
  if (!measurementType) return undefined;
  
  const normalized = measurementType.trim().toUpperCase();
  const mapping: Record<string, string> = {
    'ELECTRICITY': 'ELECTRIC',
    'ELECTRIC': 'ELECTRIC',
    'GAS': 'GAS',
    'WATER': 'WATER',
    'DUAL_FUEL': 'DUAL',
    'DUALFUEL': 'DUAL',
    'DUAL': 'DUAL'
  };
  
  return mapping[normalized] || normalized;
};

export const extractProjectFuelType = (
  projectAttributes: { fuel_type?: string | null } | null | undefined,
  fetchedAttributes: { allowed_measurement_type?: string } | null | undefined
): string | undefined => {
  let fuelTypeValue: string | null | undefined = projectAttributes?.fuel_type;
  
  if (!fuelTypeValue && fetchedAttributes?.allowed_measurement_type) {
    fuelTypeValue = fetchedAttributes.allowed_measurement_type;
  }
  
  if (!fuelTypeValue) {
    return undefined;
  }
  
  let fuelType: string | undefined = undefined;
  if (typeof fuelTypeValue === 'string') {
    const fuelTypes = fuelTypeValue.split(',').map((f: string) => f.trim());
    const firstFuelType = fuelTypes[0];
    fuelType = mapMeasurementTypeToFuelType(firstFuelType);
  } else if (Array.isArray(fuelTypeValue)) {
    const fuelTypeArray = fuelTypeValue as any[];
    if (fuelTypeArray.length > 0) {
      const firstFuelType = String(fuelTypeArray[0]);
      fuelType = mapMeasurementTypeToFuelType(firstFuelType);
    }
  }
  
  return fuelType;
};

export const getAvailableFuelTypes = (
  allowedMeasurementType: string | null | undefined
): string[] => {
  if (!allowedMeasurementType) {
    return ['ELECTRIC']; 
  }
  
  const fuelTypes = allowedMeasurementType
    .split(',')
    .map((f: string) => f.trim())
    .map(mapMeasurementTypeToFuelType)
    .filter((f): f is string => f !== undefined) 
    .filter((f: string, index: number, arr: string[]) => arr.indexOf(f) === index);
  
  if (fuelTypes.length >= 2 && !fuelTypes.includes('DUAL')) {
    fuelTypes.push('DUAL');
  }
  
  return fuelTypes.length > 0 ? fuelTypes : ['ELECTRIC'];
};

